const STATES_CONFIG_ORIGINAL = {
  init: {
    on: {
      SELECT: 'show_categories'
    }
  },
  show_categories: {
    on: {
      BACK: 'init',
      SELECT: 'show_sections'
    }
  },
  show_sections: {
    on: {
      BACK: 'show_categories',
      SELECT: 'show_form'
    }
  },
  show_form: {
    on: {
      BACK: 'show_sections',
      NEXT: 'show_success'
    }
  },
  show_success: {
    on: {
      END: 'init'
    }
  }
};

export const STATE_CONFIG = {
  init: {
    on: {
      SELECT: 'show_categories'
    }
  },
  show_categories: {
    on: {
      BACK: 'init',
      SELECT: 'show_form',
      SELECT_BOOKINGS: 'show_bookings'
    }
  },
  show_bookings: {
    on: {
      BACK: 'show_categories',
      SELECT: 'show_form'
    }
  },
  show_form: {
    on: {
      BACK: 'show_categories',
      NEXT: 'show_success'
    }
  },
  show_success: {
    on: {
      END: 'init'
    }
  }
};

export default STATES_CONFIG_ORIGINAL;
